'use strict';

import { WebFormRequest } from 'components/webFormRequest';
import { isTouchDevice } from '../util/common';
import Accordion from './accordion';
import { addInputClearIcon } from '../util/form';

class WebFormRequestIntimissimi extends WebFormRequest {
    observeSelection () {
        var _self = this;

        if (!isTouchDevice()) {
            this.form.find('.contactType').chosen({
                disable_search: true
            });
        }

        // Case Type selection
        this.form.on('change', '.contactType', function (_e) {
            $(this).css('color', 'black');
            var value = $(this).val();

            if (value === '') {
                $('.js-webFormRequest-contactSubTypeCell', _self.form).addClass('visibility-hidden');
                return;
            }

            $('.js-webFormRequest-contactFormNextStep', _self.form).prop('disabled', true);

            // Load SubTypes
            var question = $('option:selected', this).data('value');
            var url = $(this).data('url') + '?question=' + encodeURIComponent(question);
            var defaultLabel = $(this).data('default-label');
            $.spinner().start();
            $('.pre-contact-section', _self.form).html('');
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $.spinner().stop();

                    // Empty select and fill with default label
                    const $select = $('.contactSubType', _self.form);
                    $select.empty().append($('<option>', {
                        value: '',
                        text: defaultLabel,
                        disabled: true,
                        selected: true
                    }));
                    $('.js-webFormRequest-contactSubTypeCell', _self.form).removeClass('visibility-hidden');

                    // Fill with subcategories list
                    if ('subcategories' in data && data.subcategories) {
                        data.subcategories.forEach(option => {
                            $select.append($('<option>', {
                                value: option.id,
                                text: option.label,
                                'data-value': option.value
                            }));
                        });
                    }

                    if (!$select.data('chosen') && !isTouchDevice()) {
                        $select.chosen({
                            disable_search: true
                        });
                    } else {
                        $select.val('').trigger('chosen:updated');
                    }

                    // Fill recap
                    var selectedType = $('.contactType option:selected', _self.form).text();
                    $('.contact-form-recap-type', _self.form).text(selectedType);
                },
                error: function (err) {
                    $.spinner().stop();
                    console.log(err);
                }
            });
        });

        // Case SubType selection
        this.form.on('change', '.contactSubType', function (_e) {

            $(this).css('color', 'black');

            var option = $('option:selected', this);
            $('.contact-form-recap-subtype', _self.form).text(option.text());
            $('.js-webFormRequest-contactFormNextStep', _self.form).prop('disabled', option.is(':disabled'));
            const type = _self.getSelectedType();
            const subtype = _self.getSelectedSubtype();
            var url = $(this).data('url') + '?type=' + encodeURIComponent(type) + '&subtype=' + encodeURIComponent(subtype);
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'GET',
                success: function (data) {
                    $.spinner().stop();
                    $('.pre-contact-section', _self.form).html(data);
                    Accordion.setup(_self.form.find('.faqs .accordion'));
                },
                error: function (err) {
                    $.spinner().stop();
                    console.log(err);
                }
            });
        });

        // CTA "Proceed"
        this.form.on('click', '.js-webFormRequest-contactFormNextStep', function (_e) {
            _self.stepOne.addClass('hidden');
            _self.stepTwo.removeClass('hidden');
            $('.js-webFormRequest-contactFormStepOne').addClass('hidden');
            $('.js-webFormRequest-formGroupContent').addClass('hidden');
            $('.js-webFormRequest-contactFormNextStep').addClass('hidden');
            $('.web-form-request-modal .tingle-modal-box').addClass('form-dimensions');
            $('.grid-container-height').removeClass('fix-height');
            $('input[type=text], input[type=email]', _self.stepTwo).each(function (index, inputItem) {
                addInputClearIcon(inputItem);
            });
            let $modal = $('.web-form-request-modal');
            if ($modal.length > 0) {
                $('.web-form-request-modal').find('.tingle-modal-box__content').scrollTop(0);
            } else {
                $(window).scrollTop(0);
            }

            // Enable send button on input first change
            const $inputs = $(_self.form).find('input, textarea');
            const enableButtonListener = function () {
                $(_self.form).find('.js-webFormRequest-buttonSend').prop('disabled', false);
                $inputs.off('input', enableButtonListener);
            };
            $inputs.on('input', enableButtonListener);
        });

        // Edit selection
        this.form.on('click', '.edit-selection', function (_e) {
            _self.stepOne.removeClass('hidden');
            _self.stepTwo.addClass('hidden');
            $('.js-webFormRequest-formGroupContent').removeClass('hidden');
            $('.js-webFormRequest-contactFormNextStep').removeClass('hidden');
            $('.js-webFormRequest-contactFormStepOne').removeClass('hidden');
            $('.contact-form-step-two').addClass('hidden');
            $('.web-form-request-modal .tingle-modal-box').removeClass('form-dimensions');
            $('.grid-container-height').addClass('fix-height');
        });

        // Enable the first step if the user reopen the modal without refreshing the page
        this.form.on('click', '.close-button', function (_e) {
            $('.js-webFormRequest-formGroupContent').removeClass('hidden');
            $('.js-webFormRequest-contactFormNextStep').removeClass('hidden');
        });
    }
}

const webFormRequest = new WebFormRequestIntimissimi();
export default webFormRequest;
